import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetCustomerListQueryVariables = Types.Exact<{
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
}>;


export type GetCustomerListQuery = { __typename?: 'query_root', customers: Array<{ __typename?: 'customers', id: number, active: number, address?: string | null, email?: string | null, name?: string | null, phone?: string | null, status?: string | null, moves_aggregate: { __typename?: 'moves_aggregate', aggregate?: { __typename?: 'moves_aggregate_fields', count: number } | null }, organization?: { __typename?: 'organizations', id: number, name: string } | null }> };

export type GetCustomerDetailsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
  start60: Types.Scalars['timestamptz']['input'];
  start30: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
}>;


export type GetCustomerDetailsQuery = { __typename?: 'query_root', customers: Array<{ __typename?: 'customers', id: number, active: number, auto_pay: boolean, billing_frequency: string, branded: boolean, category?: string | null, config?: object | null, createdat?: string | null, email?: string | null, location_id?: number | null, name?: string | null, notify_billing?: boolean | null, organization_id?: number | null, payment_terms: number, phone?: string | null, status?: string | null, updatedat?: string | null, location?: { __typename?: 'locations', id: number, address?: string | null, address_line_one?: string | null, address_line_two?: string | null, city?: string | null, customer_id?: number | null, email?: string | null, favorite: boolean, latitude?: number | null, longitude?: number | null, name?: string | null, nickname?: string | null, phone?: string | null, place_id?: string | null, region_id?: number | null, state?: string | null, timezone?: string | null, type: string, zip_code?: string | null } | null, previous30Moves: Array<{ __typename?: 'moves', id: number, accountsReceivable?: { __typename?: 'armoves', id: number, due_amount: number } | null }>, current30Moves: Array<{ __typename?: 'moves', id: number, accountsReceivable?: { __typename?: 'armoves', id: number, due_amount: number } | null }>, organization?: { __typename?: 'organizations', id: number, config?: object | null, name: string } | null }>, organizations: Array<{ __typename?: 'organizations', id: number, name: string }> };

export type GetOrganizationsForCustomerFormQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOrganizationsForCustomerFormQuery = { __typename?: 'query_root', organizations: Array<{ __typename?: 'organizations', id: number, name: string, category?: string | null }> };

export type GetActiveCustomersForSelectQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetActiveCustomersForSelectQuery = { __typename?: 'query_root', customers: Array<{ __typename?: 'customers', id: number, name?: string | null }> };

export type GetAllCustomersForSelectQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllCustomersForSelectQuery = { __typename?: 'query_root', customers: Array<{ __typename?: 'customers', id: number, name?: string | null }> };

export type GetCustomersQueryVariables = Types.Exact<{
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
}>;


export type GetCustomersQuery = { __typename?: 'query_root', customers: Array<{ __typename?: 'customers', id: number, active: number, address?: string | null, email?: string | null, name?: string | null, phone?: string | null, status?: string | null, moves_aggregate: { __typename?: 'moves_aggregate', aggregate?: { __typename?: 'moves_aggregate_fields', count: number } | null }, organization?: { __typename?: 'organizations', id: number, name: string } | null, locations: Array<{ __typename?: 'locations', id: number, latitude?: number | null, longitude?: number | null }> }> };


export const GetCustomerListDocument = gql`
    query GetCustomerList($start: timestamptz!, $end: timestamptz!) {
  customers(order_by: {name: asc}) {
    id
    active
    address
    email
    name
    phone
    status
    moves_aggregate(
      where: {active: {_eq: 1}, chargeable: {_eq: true}, move_type: {_eq: "drive"}, pickup_time: {_gte: $start, _lte: $end}, status: {_eq: "delivery successful"}, _or: [{cancel_status: {_is_null: true}}, {cancel_status: {_eq: "started"}}]}
    ) {
      aggregate {
        count
      }
    }
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCustomerListQuery__
 *
 * To run a query within a React component, call `useGetCustomerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerListQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetCustomerListQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerListQuery, GetCustomerListQueryVariables> & ({ variables: GetCustomerListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerListQuery, GetCustomerListQueryVariables>(GetCustomerListDocument, options);
      }
export function useGetCustomerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerListQuery, GetCustomerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerListQuery, GetCustomerListQueryVariables>(GetCustomerListDocument, options);
        }
// @ts-ignore
export function useGetCustomerListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerListQuery, GetCustomerListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerListQuery, GetCustomerListQueryVariables>;
export function useGetCustomerListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerListQuery, GetCustomerListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerListQuery | undefined, GetCustomerListQueryVariables>;
export function useGetCustomerListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerListQuery, GetCustomerListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerListQuery, GetCustomerListQueryVariables>(GetCustomerListDocument, options);
        }
export type GetCustomerListQueryHookResult = ReturnType<typeof useGetCustomerListQuery>;
export type GetCustomerListLazyQueryHookResult = ReturnType<typeof useGetCustomerListLazyQuery>;
export type GetCustomerListSuspenseQueryHookResult = ReturnType<typeof useGetCustomerListSuspenseQuery>;
export type GetCustomerListQueryResult = Apollo.QueryResult<GetCustomerListQuery, GetCustomerListQueryVariables>;
export const GetCustomerDetailsDocument = gql`
    query GetCustomerDetails($customerId: bigint!, $start60: timestamptz!, $start30: timestamptz!, $end: timestamptz!) {
  customers(where: {id: {_eq: $customerId}}) {
    id
    active
    auto_pay
    billing_frequency
    branded
    category
    config
    createdat
    email
    location_id
    name
    notify_billing
    organization_id
    payment_terms
    phone
    status
    updatedat
    location {
      id
      address
      address_line_one
      address_line_two
      city
      customer_id
      email
      favorite
      latitude
      longitude
      name
      nickname
      phone
      place_id
      region_id
      state
      timezone
      type
      zip_code
    }
    previous30Moves: moves(
      where: {active: {_eq: 1}, chargeable: {_eq: true}, move_type: {_eq: "drive"}, pickup_time: {_gte: $start60, _lte: $start30}, status: {_eq: "delivery successful"}, _or: [{cancel_status: {_is_null: true}}, {cancel_status: {_eq: "started"}}]}
    ) {
      id
      accountsReceivable {
        id
        due_amount
      }
    }
    current30Moves: moves(
      where: {active: {_eq: 1}, chargeable: {_eq: true}, move_type: {_eq: "drive"}, pickup_time: {_gte: $start30, _lte: $end}, status: {_eq: "delivery successful"}, _or: [{cancel_status: {_is_null: true}}, {cancel_status: {_eq: "started"}}]}
    ) {
      id
      accountsReceivable {
        id
        due_amount
      }
    }
    organization {
      id
      config
      name
    }
  }
  organizations(order_by: {name: asc}) {
    id
    name
  }
}
    `;

/**
 * __useGetCustomerDetailsQuery__
 *
 * To run a query within a React component, call `useGetCustomerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerDetailsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      start60: // value for 'start60'
 *      start30: // value for 'start30'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetCustomerDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables> & ({ variables: GetCustomerDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>(GetCustomerDetailsDocument, options);
      }
export function useGetCustomerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>(GetCustomerDetailsDocument, options);
        }
// @ts-ignore
export function useGetCustomerDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>;
export function useGetCustomerDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerDetailsQuery | undefined, GetCustomerDetailsQueryVariables>;
export function useGetCustomerDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>(GetCustomerDetailsDocument, options);
        }
export type GetCustomerDetailsQueryHookResult = ReturnType<typeof useGetCustomerDetailsQuery>;
export type GetCustomerDetailsLazyQueryHookResult = ReturnType<typeof useGetCustomerDetailsLazyQuery>;
export type GetCustomerDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCustomerDetailsSuspenseQuery>;
export type GetCustomerDetailsQueryResult = Apollo.QueryResult<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>;
export const GetOrganizationsForCustomerFormDocument = gql`
    query GetOrganizationsForCustomerForm {
  organizations(order_by: {name: asc}) {
    id
    name
    category
  }
}
    `;

/**
 * __useGetOrganizationsForCustomerFormQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsForCustomerFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsForCustomerFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsForCustomerFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationsForCustomerFormQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsForCustomerFormQuery, GetOrganizationsForCustomerFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsForCustomerFormQuery, GetOrganizationsForCustomerFormQueryVariables>(GetOrganizationsForCustomerFormDocument, options);
      }
export function useGetOrganizationsForCustomerFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsForCustomerFormQuery, GetOrganizationsForCustomerFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsForCustomerFormQuery, GetOrganizationsForCustomerFormQueryVariables>(GetOrganizationsForCustomerFormDocument, options);
        }
// @ts-ignore
export function useGetOrganizationsForCustomerFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationsForCustomerFormQuery, GetOrganizationsForCustomerFormQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationsForCustomerFormQuery, GetOrganizationsForCustomerFormQueryVariables>;
export function useGetOrganizationsForCustomerFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsForCustomerFormQuery, GetOrganizationsForCustomerFormQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationsForCustomerFormQuery | undefined, GetOrganizationsForCustomerFormQueryVariables>;
export function useGetOrganizationsForCustomerFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsForCustomerFormQuery, GetOrganizationsForCustomerFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationsForCustomerFormQuery, GetOrganizationsForCustomerFormQueryVariables>(GetOrganizationsForCustomerFormDocument, options);
        }
export type GetOrganizationsForCustomerFormQueryHookResult = ReturnType<typeof useGetOrganizationsForCustomerFormQuery>;
export type GetOrganizationsForCustomerFormLazyQueryHookResult = ReturnType<typeof useGetOrganizationsForCustomerFormLazyQuery>;
export type GetOrganizationsForCustomerFormSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsForCustomerFormSuspenseQuery>;
export type GetOrganizationsForCustomerFormQueryResult = Apollo.QueryResult<GetOrganizationsForCustomerFormQuery, GetOrganizationsForCustomerFormQueryVariables>;
export const GetActiveCustomersForSelectDocument = gql`
    query GetActiveCustomersForSelect {
  customers(where: {active: {_eq: 1}}, order_by: {name: asc}) {
    id
    name
  }
}
    `;

/**
 * __useGetActiveCustomersForSelectQuery__
 *
 * To run a query within a React component, call `useGetActiveCustomersForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCustomersForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveCustomersForSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveCustomersForSelectQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveCustomersForSelectQuery, GetActiveCustomersForSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveCustomersForSelectQuery, GetActiveCustomersForSelectQueryVariables>(GetActiveCustomersForSelectDocument, options);
      }
export function useGetActiveCustomersForSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveCustomersForSelectQuery, GetActiveCustomersForSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveCustomersForSelectQuery, GetActiveCustomersForSelectQueryVariables>(GetActiveCustomersForSelectDocument, options);
        }
// @ts-ignore
export function useGetActiveCustomersForSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveCustomersForSelectQuery, GetActiveCustomersForSelectQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveCustomersForSelectQuery, GetActiveCustomersForSelectQueryVariables>;
export function useGetActiveCustomersForSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveCustomersForSelectQuery, GetActiveCustomersForSelectQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveCustomersForSelectQuery | undefined, GetActiveCustomersForSelectQueryVariables>;
export function useGetActiveCustomersForSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveCustomersForSelectQuery, GetActiveCustomersForSelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveCustomersForSelectQuery, GetActiveCustomersForSelectQueryVariables>(GetActiveCustomersForSelectDocument, options);
        }
export type GetActiveCustomersForSelectQueryHookResult = ReturnType<typeof useGetActiveCustomersForSelectQuery>;
export type GetActiveCustomersForSelectLazyQueryHookResult = ReturnType<typeof useGetActiveCustomersForSelectLazyQuery>;
export type GetActiveCustomersForSelectSuspenseQueryHookResult = ReturnType<typeof useGetActiveCustomersForSelectSuspenseQuery>;
export type GetActiveCustomersForSelectQueryResult = Apollo.QueryResult<GetActiveCustomersForSelectQuery, GetActiveCustomersForSelectQueryVariables>;
export const GetAllCustomersForSelectDocument = gql`
    query GetAllCustomersForSelect {
  customers(order_by: {name: asc}) {
    id
    name
  }
}
    `;

/**
 * __useGetAllCustomersForSelectQuery__
 *
 * To run a query within a React component, call `useGetAllCustomersForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCustomersForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCustomersForSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCustomersForSelectQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCustomersForSelectQuery, GetAllCustomersForSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCustomersForSelectQuery, GetAllCustomersForSelectQueryVariables>(GetAllCustomersForSelectDocument, options);
      }
export function useGetAllCustomersForSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCustomersForSelectQuery, GetAllCustomersForSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCustomersForSelectQuery, GetAllCustomersForSelectQueryVariables>(GetAllCustomersForSelectDocument, options);
        }
// @ts-ignore
export function useGetAllCustomersForSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCustomersForSelectQuery, GetAllCustomersForSelectQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCustomersForSelectQuery, GetAllCustomersForSelectQueryVariables>;
export function useGetAllCustomersForSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCustomersForSelectQuery, GetAllCustomersForSelectQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCustomersForSelectQuery | undefined, GetAllCustomersForSelectQueryVariables>;
export function useGetAllCustomersForSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCustomersForSelectQuery, GetAllCustomersForSelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCustomersForSelectQuery, GetAllCustomersForSelectQueryVariables>(GetAllCustomersForSelectDocument, options);
        }
export type GetAllCustomersForSelectQueryHookResult = ReturnType<typeof useGetAllCustomersForSelectQuery>;
export type GetAllCustomersForSelectLazyQueryHookResult = ReturnType<typeof useGetAllCustomersForSelectLazyQuery>;
export type GetAllCustomersForSelectSuspenseQueryHookResult = ReturnType<typeof useGetAllCustomersForSelectSuspenseQuery>;
export type GetAllCustomersForSelectQueryResult = Apollo.QueryResult<GetAllCustomersForSelectQuery, GetAllCustomersForSelectQueryVariables>;
export const GetCustomersDocument = gql`
    query GetCustomers($start: timestamptz!, $end: timestamptz!) {
  customers(order_by: {name: asc}) {
    id
    active
    address
    email
    name
    phone
    status
    moves_aggregate(
      where: {active: {_eq: 1}, chargeable: {_eq: true}, move_type: {_eq: "drive"}, pickup_time: {_gte: $start, _lte: $end}, status: {_eq: "delivery successful"}, _or: [{cancel_status: {_is_null: true}}, {cancel_status: {_eq: "started"}}]}
    ) {
      aggregate {
        count
      }
    }
    organization {
      id
      name
    }
    locations(limit: 1, where: {latitude: {_is_null: false}}) {
      id
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useGetCustomersQuery__
 *
 * To run a query within a React component, call `useGetCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetCustomersQuery(baseOptions: Apollo.QueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables> & ({ variables: GetCustomersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
      }
export function useGetCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
// @ts-ignore
export function useGetCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomersQuery, GetCustomersQueryVariables>;
export function useGetCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomersQuery | undefined, GetCustomersQueryVariables>;
export function useGetCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
export type GetCustomersQueryHookResult = ReturnType<typeof useGetCustomersQuery>;
export type GetCustomersLazyQueryHookResult = ReturnType<typeof useGetCustomersLazyQuery>;
export type GetCustomersSuspenseQueryHookResult = ReturnType<typeof useGetCustomersSuspenseQuery>;
export type GetCustomersQueryResult = Apollo.QueryResult<GetCustomersQuery, GetCustomersQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/customers/gql/queries.gql}
 */
export async function getActiveCustomersForSelect(
  variables: GetActiveCustomersForSelectQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetActiveCustomersForSelectQuery['customers']>
export async function getActiveCustomersForSelect(
  variables: GetActiveCustomersForSelectQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetActiveCustomersForSelectQuery>
export async function getActiveCustomersForSelect(
  variables: GetActiveCustomersForSelectQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetActiveCustomersForSelectQuery['customers'] | GetActiveCustomersForSelectQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetActiveCustomersForSelectQuery>(
    GetActiveCustomersForSelectDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.customers
}

/**
 * @source {@link src/features/customers/gql/queries.gql}
 */
export async function getAllCustomersForSelect(
  variables: GetAllCustomersForSelectQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetAllCustomersForSelectQuery['customers']>
export async function getAllCustomersForSelect(
  variables: GetAllCustomersForSelectQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetAllCustomersForSelectQuery>
export async function getAllCustomersForSelect(
  variables: GetAllCustomersForSelectQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetAllCustomersForSelectQuery['customers'] | GetAllCustomersForSelectQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetAllCustomersForSelectQuery>(
    GetAllCustomersForSelectDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.customers
}

/**
 * Multiple root fields (customers, organizations): returns the full response object.
 * @source {@link src/features/customers/gql/queries.gql}
 */
export async function getCustomerDetails(
  variables: GetCustomerDetailsQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetCustomerDetailsQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetCustomerDetailsQuery>(
    GetCustomerDetailsDocument,
    variables,
    requestOptions
  )
}

/**
 * @source {@link src/features/customers/gql/queries.gql}
 */
export async function getCustomerList(
  variables: GetCustomerListQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetCustomerListQuery['customers']>
export async function getCustomerList(
  variables: GetCustomerListQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetCustomerListQuery>
export async function getCustomerList(
  variables: GetCustomerListQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetCustomerListQuery['customers'] | GetCustomerListQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetCustomerListQuery>(
    GetCustomerListDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.customers
}

/**
 * @source {@link src/features/customers/gql/queries.gql}
 */
export async function getCustomers(
  variables: GetCustomersQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetCustomersQuery['customers']>
export async function getCustomers(
  variables: GetCustomersQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetCustomersQuery>
export async function getCustomers(
  variables: GetCustomersQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetCustomersQuery['customers'] | GetCustomersQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetCustomersQuery>(
    GetCustomersDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.customers
}

/**
 * @source {@link src/features/customers/gql/queries.gql}
 */
export async function getOrganizationsForCustomerForm(
  variables: GetOrganizationsForCustomerFormQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetOrganizationsForCustomerFormQuery['organizations']>
export async function getOrganizationsForCustomerForm(
  variables: GetOrganizationsForCustomerFormQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetOrganizationsForCustomerFormQuery>
export async function getOrganizationsForCustomerForm(
  variables: GetOrganizationsForCustomerFormQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetOrganizationsForCustomerFormQuery['organizations'] | GetOrganizationsForCustomerFormQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetOrganizationsForCustomerFormQuery>(
    GetOrganizationsForCustomerFormDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.organizations
}